<template>
	<div class="finance container-fluid py-3">
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>MAINTENANCE REPORT</h4>
			</div>

			<div class="col-md-12 mb-3">
				<el-row class="scrollable-row">
					<el-button :type="tabIndex == 0 ? 'primary' : 'plain'" class="" size="medium" @click="selectTab(0)"> <i class="fa fa-angle-down"></i> &nbsp; ATG</el-button>
					<el-button :type="tabIndex == 1 ? 'primary' : 'plain'" class="" size="medium" @click="selectTab(1)"> <i class="fa fa-angle-down"></i> &nbsp; SPBU Update</el-button>
					<el-button :type="tabIndex == 2 ? 'primary' : 'plain'" class="" size="medium" @click="selectTab(2)"> <i class="fa fa-angle-down"></i> &nbsp; Store Update</el-button>
					<el-button :type="tabIndex == 3 ? 'primary' : 'plain'" class="" size="medium" @click="selectTab(3)"> <i class="fa fa-angle-down"></i> &nbsp; Outlet</el-button>
					<el-button :type="tabIndex == 4 ? 'primary' : 'plain'" class="" size="medium" @click="selectTab(4)"> <i class="fa fa-angle-down"></i> &nbsp; Self Service</el-button>
					<el-button :type="tabIndex == 5 ? 'primary' : 'plain'" class="" size="medium" @click="selectTab(5)"> <i class="fa fa-angle-down"></i> &nbsp; Pump Inactive</el-button>
					<el-button :type="tabIndex == 6 ? 'primary' : 'plain'" class="" size="medium" @click="selectTab(6)"> <i class="fa fa-angle-down"></i> &nbsp; Login History</el-button>
					<el-button :type="tabIndex == 8 ? 'primary' : 'plain'" class="" size="medium" @click="selectTab(8)"> <i class="fa fa-angle-down"></i> &nbsp; Pinsyst Last Update</el-button>
					<el-button :type="tabIndex == 9 ? 'primary' : 'plain'" class="" size="medium" @click="selectTab(9)"> <i class="fa fa-angle-down"></i> &nbsp; Device Tracking</el-button>
					<el-button :type="tabIndex == 10 ? 'primary' : 'plain'" class="" size="medium" @click="selectTab(10)"> <i class="fa fa-angle-down"></i> &nbsp; Station Database Size</el-button>
				</el-row>
			</div>

			<div class="col-md-12 mb-2">
				<el-card shadow="never" class="box-card col-md-12 mb-0" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '10px', paddingBottom: '16px' }">
					<div>
						<div :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index">
							<MaintenanceReportTab v-show="tabIndex == item.index" :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label" :showTitle="true"/>
						</div>
						<div >
							<MaintenanceReportOutlets v-show="tabIndex == '3'" :tabIndex="'3'" :tabName="'outlets'" :tabLabel="'Outlet'" :showTitle="true"/>
						</div>
						<div>
							<MaintenanceReportSelfService v-show="tabIndex == '4'" :tabIndex="'4'" :tabName="'selfservice'" :tabLabel="'Self Service'" :showTitle="true"/>
						</div>
						<div>
							<MaintenanceReportTab v-show="tabIndex == '5'" :tabIndex="'5'" :tabName="'last_pump_transaction'" :tabLabel="'Last Pump Transaction'" :showTitle="true"/>
						</div>

						<div>
							<MaintenanceReportTab v-show="tabIndex == '6'" :tabIndex="'6'" :tabName="'login_history'" :tabLabel="'Login History'" :showTitle="true"/>
						</div>

						<div>
							<MaintenanceReportPinsyst v-show="tabIndex == '8'" :tabIndex="'8'" :tabName="'pinsyst'" :tabLabel="'Pinsyst Last Update'" :showTitle="true"/>
						</div>

						<div>
							<MaintenanceReportTabDeviceTracking v-show="tabIndex == '9'" :tabIndex="'9'" :tabName="'device_tracking'" :tabLabel="'Device Tracking'" :showTitle="true"/>
						</div>

                        <div>
							<MaintenanceReportTab v-show="tabIndex == '10'" :tabIndex="'10'" :tabName="'station_database_size'" :tabLabel="'Station Database Size'" :showTitle="true"/>
						</div>

					</div>
				</el-card>
			</div>

			<div class="col-md-12 p-0" v-if="false">
				<el-card class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>MAINTENANCE REPORT</strong></span>
					</div>
					<div>
						<div class="mb-3" style="margin-top:-21px;">
							<el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
									<MaintenanceReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>

								<el-tab-pane :label="'Outlets'" :name="'3'"  >
									<MaintenanceReportOutlets :tabIndex="'3'" :tabName="'outlets'" :tabLabel="'Outlets'"/>
								</el-tab-pane>

								<el-tab-pane :label="'Self Service'" :name="'4'"  >
									<MaintenanceReportSelfService :tabIndex="'4'" :tabName="'selfservice'" :tabLabel="'Self Service'"/>
								</el-tab-pane>

								<el-tab-pane :label="'Pump Inactive'" :name="'5'"  >
									<MaintenanceReportTab :tabIndex="'5'" :tabName="'last_pump_transaction'" :tabLabel="'Last Pump Transaction'"/>
								</el-tab-pane>

								<el-tab-pane :label="'Login History'" :name="'6'"  >
									<MaintenanceReportTab :tabIndex="'6'" :tabName="'login_history'" :tabLabel="'Login History'"/>
								</el-tab-pane>

								<el-tab-pane :label="'Pinsyst Last Update'" :name="'8'"  >
									<MaintenanceReportPinsyst :tabIndex="'8'" :tabName="'pinsyst'" :tabLabel="'Pinsyst Last Update'"/>
								</el-tab-pane>

								<el-tab-pane :label="'Device Tracking'" :name="'9'"  >
									<MaintenanceReportTabDeviceTracking :tabIndex="'9'" :tabName="'device_tracking'" :tabLabel="'Device Tracking'"/>
								</el-tab-pane>

                                <el-tab-pane :label="'Station Database Size'" :name="'10'"  >
									<MaintenanceReportTab :tabIndex="'10'" :tabName="'station_database_size'" :tabLabel="'Station Database Size'"/>
								</el-tab-pane>

							</el-tabs>
						</div>
					</div>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>

import Bright from '@/components/page/Bright.js'
import MaintenanceReportTab from '@/views/pages/MaintenanceReport/MaintenanceReportTab.vue'
import MaintenanceReportOutlets from '@/views/pages/MaintenanceReport/MaintenanceReportOutlets.vue'
import MaintenanceReportSelfService from '@/views/pages/MaintenanceReport/MaintenanceReportSelfService.vue'
import MaintenanceReportPinsyst from '@/views/pages/MaintenanceReport/MaintenanceReportPinsyst.vue'
import MaintenanceReportTabDeviceTracking from '@/views/pages/MaintenanceReport/MaintenanceReportTabDeviceTracking.vue'

export default
{
	extends: Bright,
	components: {
		MaintenanceReportTab,
		MaintenanceReportOutlets,
		MaintenanceReportSelfService,
		MaintenanceReportPinsyst,
		MaintenanceReportTabDeviceTracking,
	},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0,
			tabList:[
				{label:'ATG', name: 'atg', index: '0' },
				{label:'SPBU Update', name: 'spbuupdate', index: '1' },
				{label:'Store Update', name: 'storeupdate', index: '2' },
				//{label:'Outlets', name: 'outlets', index: '3' },
				//{label:'Self Service', name: 'selfservice', index: '4' },
				//{label:'Last Pump Transaction', name: 'last_pump_transaction', index: '5' },
			],
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	},
    mounted()
    {
        this.$emit('childrenRoute');
    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

		selectTab(index) {
			this.tabIndex = `${index}`; //String(index);
			//console.log('index: ' + index);
		}

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>
